import type { ReactNode } from 'react';

// Shared Device Details building blocks (DeviceDetails, DmrDiagnostics).
const NOT_AVAILABLE = 'Not available';

export const fmt = (value: string | number | null | undefined): string =>
  value === null || value === undefined || value === '' ? NOT_AVAILABLE : String(value);

export function Field({ label, value }: { label: string; value: string | number | null | undefined }) {
  return (
    <div>
      <p className="text-xs text-gray-400 uppercase font-semibold">{label}</p>
      <p className="text-white">{fmt(value)}</p>
    </div>
  );
}

export function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="bg-gray-800 rounded-lg border border-gray-700 p-4 space-y-3">
      <h3 className="text-lg font-bold">{title}</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">{children}</div>
    </div>
  );
}
